







































































































































































































































































































import BaseVue from "@/core/BaseVue";
import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import GenericAdd from "@/core/Generics/GenericAdd";
import Institucion from "../../models/institucion.model";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TipoTramite from "@/models/tipoTramite/tipoTramite.model";
import FileService from "@/services/file.service";
import TramiteBeneficiarioContentModel from "@/models/tramite/content/tramiteBeneficiarioContent.model";
import {
  ComponentImportConfig,
  ComponentDesignConfig,
  TipoTramiteDocumento
} from "@/models/tipoTramite/index";
import ApiQueryOption from "../../models/base/ApiQueryOption.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TramiteBeneficiarioContent from "./content.vue";
import TramiteBeneficiarioResumen from "./resumen.vue";
import { SectionSetting } from "@/models/formDesigner/formDesignerControl.model";
import Documento from "@/models/documento.model";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import NameValue from "@/models/nameValue.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TipoTramiteNota from "@/models/tipoTramite/tipoTramiteNota.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import SolicitudEvaluacionHogar from '@/models/tramite/solicitud-evaluacion-hogar';
import moment from "moment";
@Component({
  components: { TramiteBeneficiarioContent, TramiteBeneficiarioResumen }
})
export default class CreacionTramite extends GenericAdd<TramiteBeneficiario> {
  solicitante = new Persona();
  beneficiario = new Beneficiario();
  beneficiarioPersona = new Persona();
  tipoTramiteSelected = new TipoTramite();
  initPrioridad = new NameValue();
  prioridad = new NameValue();
  notasModalActive = false;

  componentImportedRepo = new BaseRepository<ComponentImportConfig>(
    "ComponentImportConfig"
  );
  componentDesignedRepo = new BaseRepository<ComponentDesignConfig>(
    "ComponentDesignConfig"
  );
  tipoTramiteConfig:
    | ComponentImportConfig
    | ComponentDesignConfig
    | null = null;

  tipoDocumentos: any[] = [];
  loading = false;
  //  notaTableConfig = new BTableConfig<TipoTramiteNota>();

  constructor() {
    super();
    this.controller = "TramiteBeneficiario";
    this.model = new TramiteBeneficiario();
  }
  backtoProfile() {
    this.$router.push("/");
  }
  async created() {
    // this.notaTableConfig.controller = "TipoTramiteNota";
    // this.notaTableConfig.enableDefaultColumns = false;
    // this.notaTableConfig.activeActions = false;
    // this.notaTableConfig.loadOnMount = false;
    //   this.notaTableConfig.insertColumns(new BTableColumn("descripcion", "Nota"));
    await this.initData();
  }
  async initData() {
    this.solicitante = this.copy(this.user.persona);
    this.model.personaId = this.solicitante.id;
    this.beneficiario = await new BaseHttpClient("beneficiario").getAsync(`find-from-miembro-personaId/${this.solicitante.id}`);
    if (this.beneficiario) this.model.beneficiarioId = this.beneficiario.id;
  }
  cedulaBeneficiario: string | null = null;
  copyAsBeneficiario() {
    this.cedulaBeneficiario = this.solicitante.cedula as any;
  }
  get cedula() {
    let cedula = this.$route.params.cedula;
    return cedula || "";
  }
  destroyed() {
    this.model = new TramiteBeneficiario();
    this.tipoTramiteConfig = null;
  }
   get whereTipoTramite() {
    if(this.isMobile)
    return `tipoTramitePadreId=null&&psOnlineMobile`;
    return `tipoTramitePadreId=null&&psOnline`;
  }
  get whereChildrenTipoTramite() {
    if(this.isMobile)
    return `&&psOnlineMobile`;
    return `&&psOnline`;
  }
  get getTipoTramiteAction() {
    return `GetAllByDisponibilidadCiudadano/${this.model.personaId}`;
  }
  get refCedula() {
    return this.beneficiario.cedula || this.solicitante.cedula;
  }
  get refPersonaId() {
    return this.beneficiario.personaId || this.solicitante.id;
  }
  foundSolicitante(value: Persona) {
    this.solicitante = value ? value : new Persona();
    this.model.personaId = value ? value.id : undefined;
  }
  foundBeneficiario(value: Beneficiario) {
    this.cedulaBeneficiario = null;
    this.beneficiario = value || new Beneficiario();
    this.beneficiarioPersona =
      value && value.persona ? value.persona : new Persona();
    this.model.beneficiarioId = value ? value.id : undefined;
  }
  unSelectTipoTramite(value: any) {
    if (!value) this.tipoTramiteSelected = new TipoTramite();
  }
  selectTipoTramite(value: TipoTramite) {
    this.tipoTramiteSelected = value ? value : new TipoTramite();
  }
  onChangeDocs(tipos: any[], docs: TramiteBeneficiarioDocumento[]) {
    this.tipoDocumentos = tipos;
    this.model.documentos = docs;
  }
  get isComponentImported() {
    if (!this.tipoTramiteSelected) return false;
    return (
      this.tipoTramiteSelected.componentImported && !!this.tipoTramiteConfig
    );
  }
  get componentImportedProps() {
    let result: any = {};
    if (!this.isComponentImported) return result;

    //Todo GET PROFILE ATTRIBUTES VALUES
    (this.tipoTramiteConfig as ComponentImportConfig).properties.forEach(x => {
      if (x.isStaticValue) result[x.name as string] = x.staticValue;
    });
    return result;
  }
  get isEvaluacionHogar() {
    if (this.isTipoTramiteSelected)
      return this.tipoTramiteSelected.codigo === "SolicitudEvaluacionHogar";
    return false;
  }
  get isTipoTramiteSelected() {
    return this.tipoTramiteSelected.codigo != undefined ? true : false;
  }
 async validateFirtStep() {
    //
    if (!this.isTipoTramiteSelected) {
       this.showWarning("Debe seleccionar un tipo de trámite", "is-warning");
      return false;
    }

    if (this.tipoTramiteSelected.codigo === "TramiteReevaluaccionHogar") {
      let personaId = this.beneficiario.personaId || this.solicitante.id;
      let ultimaReevaluacion = await new BaseHttpClient(
        "TramiteBeneficiario"
      ).getAsync<SolicitudEvaluacionHogar>(
        `GetLastReevaluacion/${personaId}`
      );
      if (!ultimaReevaluacion || !ultimaReevaluacion.createdDate) return true;

      let last = moment(ultimaReevaluacion.createdDate);
      let nextAllowedDate = last.clone().add(1, "year");
      let nextAllowedDateLabel = nextAllowedDate.format("DD/MM/YYYY");

      if (moment().isBefore(nextAllowedDate)) {
        this.showWarning(
          `El participante debe esperar un a\u00f1o desde la \u00faltima ${this.tipoTramiteSelected.nombre} para solicitar otra. Disponible a partir del ${nextAllowedDateLabel}.`,
          "is-warning",
          5000
        );
        return false;
      }

      if (false && moment().isBefore(nextAllowedDate)) {
        this.showWarning(
          `El participante tiene menos de un año desde la última ${this.tipoTramiteSelected.nombre} que realizó`,
          "is-warning",
          5000
        );
        return false;
      }
    }
    return true;
  }
  get isCambioJefe() {
    if (this.tipoTramiteSelected && this.tipoTramiteSelected.codigo)
      return this.tipoTramiteSelected.codigo.includes("TramiteCambioJefeHogar");
    return false;
  }
  get tramiteInfoRef() {
    let info = this.$refs.tramiteInfo as any;
    return Array.isArray(info) ? info[0] : info;
  }
  get solicitudDocumentosRef() {
    let docs = this.$refs.solicitudDocumentos as any;
    return Array.isArray(docs) ? docs[0] : docs;
  }
  async validateSecondStep() {
    let info = this.tramiteInfoRef;
    if (!info) return true;

    if (this.isCambioJefe && !info.jefePropuesto) {
      this.operationFailed("Debe seleccionar el nuevo jefe de hogar");
      return false;
    }
    if (typeof info.validateStep === "function") {
      return await info.validateStep();
    }
    if (typeof info.isValid !== "function") return true;

    let result = await info.isValid();
    return result;
  }
  getMissingRequiredDocuments(tipoDocumentos: any[]) {
    return (tipoDocumentos || []).filter(
      x => x.requerido && !x.fileSelected
    );
  }
  validateRequiredDocuments() {
    let tipoDocumentos =
      (this.solicitudDocumentosRef &&
        this.solicitudDocumentosRef.tipoDocumentos) ||
      this.tipoDocumentos;
    let missingDocs = this.getMissingRequiredDocuments(tipoDocumentos);
    if (!missingDocs.length) return true;

    let names = missingDocs.map(x => x.tipoDocumentoNombre).join(", ");
    this.operationFailed(
      `Debe adjuntar los documentos requeridos de la solicitud: ${names}`
    );
    return false;
  }
  async validateCurrentForm() {
    try {
      if (!this.$validator || typeof this.$validator.validateAll !== "function")
        return true;

      const isValid = await this.$validator.validateAll();
      if (isValid)
        return true;

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
      return false;
    }
  }
  public async validate() {
    if (this.submitting || this.saving)
      return;

    this.submitting = true;
    try {
      let isValid = await this.validateCurrentForm();
      if (!isValid) return;

      let stepValid = await this.validateSecondStep();
      if (!stepValid) return;

      if (
        this.tramiteInfoRef &&
        typeof this.tramiteInfoRef.validateStep === "function" &&
        typeof this.tramiteInfoRef.isValid === "function"
      ) {
        let infoValid = await this.tramiteInfoRef.isValid();
        if (!infoValid) return;
      }

      if (!this.validateRequiredDocuments()) return;

      await this.add();
    } finally {
      this.submitting = false;
    }
  }
  public async onWizardComplete() {
    return this.validate();
  }
  showWarning(message: string, type: string, time = 3000) {
    this.$buefy.toast.open({
      message: message,
      type: type,
      duration: time
    });
  }

  showAlert(
    message: string,
    type: string,
    title = "Alerta",
    confirmText = "Ok!"
  ) {
    this.$buefy.dialog.alert({
      title: title,
      type: type,
      message: message,
      confirmText: confirmText
    });
  }
  get isComponentDesigned() {
    if (!this.tipoTramiteSelected) return false;
    return (
      this.tipoTramiteSelected.componentDesigned && !!this.tipoTramiteConfig
    );
  }

  isActiveAlertEvaluacionHogar = false;
  isActiveAlertReclamoInclusionNomina = false;
  isActiveAlertReevaluacionHogar = false;
  isActiveAlertInclusionMiembro = false;
  isActiveAlertExclusionMiembro = false;
  isActiveAlertCambioDireccion = false;
  isActiveAlertQuejasReclamos = false;

  componentDesigConfig!: ComponentDesignConfig;
  @Watch("tipoTramiteSelected", { deep: true })
  async onTipoTramiteChange(value: TipoTramite | null) {

    this.isActiveAlertEvaluacionHogar = false;
    this.isActiveAlertReclamoInclusionNomina = false;
    this.isActiveAlertReevaluacionHogar = false;
    this.isActiveAlertInclusionMiembro = false;
    this.isActiveAlertExclusionMiembro = false;
    this.isActiveAlertCambioDireccion = false;
    this.isActiveAlertQuejasReclamos = false;

    this.tipoTramiteConfig = null;

    if (!value || !value.codigo) return;

    this.isActiveAlertEvaluacionHogar = value.codigo === "SolicitudEvaluacionHogar";
    this.isActiveAlertReclamoInclusionNomina = value.codigo === "ReclamoInclusionNomina";
    this.isActiveAlertReevaluacionHogar = value.codigo === "TramiteReevaluaccionHogar";
    this.isActiveAlertInclusionMiembro = value.codigo === "TramiteCambioComposicionFamiliarInclusion";
    this.isActiveAlertExclusionMiembro = value.codigo === "TramiteCambioComposicionFamiliarExclusion";
    this.isActiveAlertCambioDireccion = value.codigo === "TramiteCambioDireccion";
    this.isActiveAlertQuejasReclamos = value.codigo === "quejasyreclamos";

    if (value) {
      //this.notaTableConfig.whereParams = `tipoTramiteId=${value.id}`;

      if (value.componentImported) {
        this.loading = true;
        this.tipoTramiteConfig = await this.componentImportedRepo.one(
          `id=${value.componentImportConfigId}`,
          "Properties"
        );
        this.loading = false;
        return;
      }

      if (value.componentDesigned) {
        this.loading = true;
        this.tipoTramiteConfig = await this.componentDesignedRepo.one(
          `id=${value.componentDesignConfigId}`,
          "Attributes.Attributes.Attributes.Attributes|Attributes.Parent"
        );
        this.componentDesigConfig = this.map<ComponentDesignConfig>(
          this.tipoTramiteConfig
        );
        this.loading = false;
        return;
      }
    }
  }

  onContentChange(value: TramiteBeneficiarioContentModel) {
    this.model.content = value
      ? this.map<TramiteBeneficiarioContentModel>(value)
      : undefined;
  }

  public async add() {
    try {
      if (this.saving) return;

      this.saving = true;
      let result = await this.repository.create(this.model);
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.$buefy.dialog.confirm({
        canCancel: false,
        title: "Solicitud enviada!",
        message: `La solicitud fue enviada con exito! <br/>Número de solicitud: <br/> <b>${result.numeroTramite}</b>`,
        type: "is-success",
        hasIcon: true,
        onConfirm: () => this.$router.push(`/`)
      });
      //  if (this.exitOnSave) this.confirmedCancel();

      //  this.$router.push(`/`);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }
  
}
